import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { Path } from '../path';
import { ModelBuilder } from './model.builder';

export class PathBuilder {
  static fromJson(json) {
    return (json)
      ? new Path(
        json.hash,
        parseNumber(json.order),
        json.route,
        ModelBuilder.fromJson(json.model)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? sortByNumber('order', mapCollection(PathBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/path.builder.ts